(function () {
  var root = document.getElementById('AppointmentScheduler');
  if (!root) return;

  // Prevent the browser from restoring a stale scroll position after the
  // add-to-bag form posts back to this page.
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

  // The scheduler's right column scrolls internally on desktop (sticky +
  // overflow-y: auto), so switching panes doesn't reset it on its own —
  // the new pane can render off-screen within that inner scroll area.
  var scrollContainer = root.closest('.appt-pdp__content');

  function scrollFormToTop() {
    if (scrollContainer) scrollContainer.scrollTop = 0;
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  var apiUrl  = (root.dataset.apiUrl || '').replace(/\/$/, '');
  var variants = JSON.parse(root.dataset.variants || '[]');

  // Supercycle resale options for this product (from the mirrored
  // supercycle.resale_configuration metafield). Booking through Resale makes
  // every appointment a Supercycle cycle, which is what the no-show fee is
  // charged against (Supercycle can only raise a charge on a cycle).
  var resaleOptions = [];
  try { resaleOptions = JSON.parse(root.dataset.resaleOptions || '[]') || []; } catch (e) {}
  var INTENT_URL = '/apps/supercycle/intents';
  var selectedVariantId = parseInt(root.dataset.selectedVariant) || (variants[0] && variants[0].id);

  function getVariant(id) {
    return variants.find(function (v) { return v.id === id; }) || variants[0];
  }

  // Internal type keys stay 'standard' / 'archive' / 'group' because the
  // booking Worker resolves Calendly event types from them. The "Group"
  // variant is presented to customers as "Shared" (people read "Group" as
  // "bring my friends" rather than "share the showroom with other customers").
  var TYPE_ALIASES = { shared: 'group' };
  var TYPE_LABELS  = { group: 'Shared' };

  function normalizeType(title) {
    var t = (title || '').toLowerCase();
    return TYPE_ALIASES[t] || t;
  }

  function typeFromVariant(id) {
    var v = getVariant(id);
    return v ? normalizeType(v.title) : 'standard';
  }

  function typeLabel(v) {
    var t = normalizeType(v.title);
    return TYPE_LABELS[t] || v.title;
  }

  var appointmentType = typeFromVariant(selectedVariantId);

  // ─── State ────────────────────────────────────────────────────────────────
  // Start on the showroom's current month (ET), not the visitor's — around
  // month boundaries a far-away device can already be in the next month.
  var nowET = new Date().toLocaleDateString('en-CA', { timeZone: 'America/New_York' });
  var viewYear  = parseInt(nowET.slice(0, 4), 10);
  var viewMonth = parseInt(nowET.slice(5, 7), 10) - 1; // 0-based

  var slotsByMonth = {};
  var loadingMonth = false;
  var selectedDate = null;
  var selectedSlot = null;

  // ─── Elements ─────────────────────────────────────────────────────────────
  var panes = {};
  root.querySelectorAll('[data-pane]').forEach(function (el) {
    panes[el.dataset.pane] = el;
  });

  var calPrev       = root.querySelector('.appt__cal-prev');
  var calNext       = root.querySelector('.appt__cal-next');
  var calMonthLabel = root.querySelector('.appt__cal-month-label');
  var calGrid       = root.querySelector('.appt__cal-grid');
  var timesEl       = root.querySelector('.appt__times');
  var statusEl      = root.querySelector('.appt__status');
  var continueBtn   = root.querySelector('.appt__continue-btn');
  var selectedDtEl  = root.querySelector('.appt__selected-dt');
  var priceEl       = root.querySelector('.appt__price');
  var feeEl         = root.querySelector('[data-appt-fee]');
  var metaEl        = root.querySelector('[data-appt-meta]');
  var productForm   = document.getElementById('appointment-product-form');

  var descEls = {};
  root.querySelectorAll('[data-desc-type]').forEach(function (el) {
    descEls[el.dataset.descType] = el;
  });

  // ─── Garment-care agreement ───────────────────────────────────────────────
  // The product form is rendered with novalidate, so a `required` attribute on
  // the checkbox wouldn't block submission — gate the submit button instead.
  // The checkbox carries its own line item property, so an unchecked box simply
  // isn't submitted and the order never claims an agreement that wasn't given.
  var agreeInput = root.querySelector('[data-appt-agree]');
  var addBtn     = root.querySelector('.appt__add-btn');

  // The add button also waits for the Supercycle intent request (see
  // requestCycleIntent) so the cycle attributes are on the form before submit.
  var intentPending = false;

  function syncAddBtn() {
    if (!addBtn) return;
    addBtn.disabled = intentPending || !!(agreeInput && !agreeInput.checked);
  }

  if (agreeInput && addBtn) {
    agreeInput.addEventListener('change', syncAddBtn);
    syncAddBtn();
  }

  var MONTH_NAMES = [
    'January','February','March','April','May','June',
    'July','August','September','October','November','December',
  ];

  // ─── Variant selection ────────────────────────────────────────────────────
  function selectVariant(id) {
    selectedVariantId = id;
    appointmentType   = typeFromVariant(id);

    // Update form variant ID
    var idInput = productForm && productForm.querySelector('[name="id"]');
    if (idInput) idInput.value = id;

    // Update price display
    updatePrice();
    updateMeta();
    updateDesc();

    // Reset calendar state
    slotsByMonth = {};
    selectedDate = null;
    selectedSlot = null;
    timesEl.innerHTML = '';
    timesEl.classList.add('appt__times--hidden');
    continueBtn.classList.add('appt__continue-btn--hidden');
    setStatus('');

    renderTypeTabs('appt-type-tabs');

    // Reload if already on the picker pane
    if (!panes.picker.classList.contains('appt__pane--hidden')) {
      loadMonth();
    }
  }

  function updatePrice() {
    var v = getVariant(selectedVariantId);
    if (!v) return;
    var amount = '$' + (v.price / 100).toFixed(0);
    if (priceEl) priceEl.innerHTML = amount;
    if (feeEl) feeEl.textContent = amount;
  }

  function updateMeta() {
    if (!metaEl) return;
    var label = appointmentType === 'group' ? 'Shared appointment' : 'Private appointment';
    metaEl.textContent = label + ' · 1 hour';
  }

  function updateDesc() {
    Object.keys(descEls).forEach(function (type) {
      descEls[type].classList.toggle('appt__desc--hidden', type !== appointmentType);
    });
  }

  // ─── Type tabs ────────────────────────────────────────────────────────────
  function renderTypeTabs(containerId) {
    var container = document.getElementById(containerId);
    if (!container) return;
    container.innerHTML = '';
    variants.forEach(function (v) {
      var el = document.createElement('button');
      el.type = 'button';
      if (v.id === selectedVariantId) {
        el.className = 'appt__type-tab appt__type-tab--active';
      } else {
        el.className = 'appt__type-tab';
        el.addEventListener('click', function () { selectVariant(v.id); });
      }
      el.textContent = typeLabel(v).toUpperCase();
      container.appendChild(el);
    });
  }

  renderTypeTabs('appt-type-tabs');
  updatePrice();
  updateMeta();
  updateDesc();

  // ─── Compare table "Book" buttons ──────────────────────────────────────────
  document.querySelectorAll('[data-select-title]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var type = normalizeType(btn.dataset.selectTitle);
      var v = variants.find(function (v) { return normalizeType(v.title) === type; });
      if (v) selectVariant(v.id);
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // ─── Pane switching ───────────────────────────────────────────────────────
  function showPane(name) {
    Object.keys(panes).forEach(function (k) {
      panes[k].classList.toggle('appt__pane--hidden', k !== name);
    });
  }

  // Book button
  var bookBtn = root.querySelector('[data-book-btn]');
  if (bookBtn) {
    bookBtn.addEventListener('click', function () {
      showPane('picker');
      loadMonth();
      scrollFormToTop();
    });
  }

  // Change button (back to picker)
  var changeBtn = root.querySelector('[data-change-btn]');
  if (changeBtn) {
    changeBtn.addEventListener('click', function () {
      showPane('picker');
      renderCalendar();
      if (selectedDate) renderTimes();
      scrollFormToTop();
    });
  }

  // ─── Month fetching ───────────────────────────────────────────────────────
  function monthKey(year, month) {
    return year + '-' + month;
  }

  function loadMonth() {
    var key = monthKey(viewYear, viewMonth);
    if (slotsByMonth[key] || loadingMonth) {
      renderCalendar();
      return;
    }
    loadingMonth = true;
    setStatus('<span class="appt__loading"><span class="appt__spinner"></span> Loading availability…</span>');

    var url = apiUrl + '/calendly/month'
      + '?type='  + encodeURIComponent(appointmentType)
      + '&year='  + viewYear
      + '&month=' + (viewMonth + 1);

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        loadingMonth = false;
        var dayMap = {};
        (data.collection || []).forEach(function (slot) {
          if (slot.status !== 'available') return;
          // Bucket by the showroom's day, not the visitor's — a Friday-evening
          // ET slot is already Saturday on clocks 3+ hours ahead of UTC, and
          // local bucketing put it under the wrong (even closed) day.
          var day = isoDayET(new Date(slot.start_time));
          if (!dayMap[day]) dayMap[day] = [];
          dayMap[day].push(slot.start_time);
        });
        slotsByMonth[key] = dayMap;
        setStatus('');
        renderCalendar();
      })
      .catch(function () {
        loadingMonth = false;
        slotsByMonth[key] = {};
        setStatus('Could not load availability — please refresh.');
        renderCalendar();
      });

    renderCalendar();
  }

  // ─── Calendar rendering ───────────────────────────────────────────────────
  function renderCalendar() {
    calMonthLabel.textContent = MONTH_NAMES[viewMonth] + ' ' + viewYear;

    // "Today" in the showroom's timezone — the grid days are ET days, so
    // comparing them against the visitor's local date can mark the current ET
    // day as past (or not-yet) for far-away visitors.
    var todayET = isoDayET(new Date());
    var isCurrentMonth =
      viewYear === parseInt(todayET.slice(0, 4), 10) &&
      viewMonth === parseInt(todayET.slice(5, 7), 10) - 1;
    calPrev.disabled = isCurrentMonth;

    // Lead time is enforced by Calendly (minimum scheduling notice on the event
    // type), and the worker only ever requests future windows — so any day that
    // comes back with slots is bookable. Only exclude days before today.

    var slots    = (slotsByMonth[monthKey(viewYear, viewMonth)] || null);
    var firstDay = new Date(viewYear, viewMonth, 1).getDay();
    var daysInMo = new Date(viewYear, viewMonth + 1, 0).getDate();

    calGrid.innerHTML = '';

    for (var i = 0; i < firstDay; i++) {
      var empty = document.createElement('div');
      empty.className = 'appt__cal-cell appt__cal-cell--empty';
      calGrid.appendChild(empty);
    }

    for (var day = 1; day <= daysInMo; day++) {
      var d        = new Date(viewYear, viewMonth, day);
      var key      = isoDay(d);
      var isPast   = key < todayET; // YYYY-MM-DD strings compare correctly
      var hasSlots = !!(slots && slots[key] && slots[key].length);
      var isSel    = key === selectedDate;

      var cell = document.createElement('button');
      cell.type      = 'button';
      cell.className = 'appt__cal-cell'
        + (isPast                         ? ' appt__cal-cell--past'      : '')
        + (!isPast && hasSlots            ? ' appt__cal-cell--available' : '')
        + (!isPast && !hasSlots && slots  ? ' appt__cal-cell--unavail'   : '')
        + (isSel                          ? ' appt__cal-cell--selected'  : '');
      cell.textContent  = day;
      cell.dataset.date = key;
      cell.disabled     = isPast || (!hasSlots && !!slots);

      if (!isPast && hasSlots) {
        cell.addEventListener('click', function () { selectDate(this.dataset.date); });
      }

      calGrid.appendChild(cell);
    }
  }

  // ─── Month navigation ─────────────────────────────────────────────────────
  function changeMonth(delta) {
    viewMonth += delta;
    if (viewMonth > 11) { viewMonth = 0;  viewYear++; }
    if (viewMonth < 0)  { viewMonth = 11; viewYear--; }
    selectedDate = null;
    selectedSlot = null;
    timesEl.innerHTML = '';
    timesEl.classList.add('appt__times--hidden');
    continueBtn.classList.add('appt__continue-btn--hidden');
    loadMonth();
  }

  calPrev.addEventListener('click', function () { changeMonth(-1); });
  calNext.addEventListener('click', function () { changeMonth(+1); });

  // ─── Date + time selection ────────────────────────────────────────────────
  // On desktop the right column scrolls internally (sticky + overflow-y: auto),
  // so the time slots can render below its fold — bring them into view so the
  // next step is visible without hunting. block: 'nearest' keeps the scroll
  // minimal and avoids yanking the whole page.
  function scrollTimesIntoView() {
    if (!window.matchMedia('(min-width: 750px)').matches) return;
    if (timesEl && timesEl.scrollIntoView) {
      timesEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  function selectDate(date) {
    selectedDate = date;
    selectedSlot = null;
    continueBtn.classList.add('appt__continue-btn--hidden');
    renderCalendar();
    renderTimes();
    scrollTimesIntoView();
  }

  function renderTimes() {
    timesEl.innerHTML = '';
    if (!selectedDate) {
      timesEl.classList.add('appt__times--hidden');
      return;
    }

    var daySlots = ((slotsByMonth[monthKey(viewYear, viewMonth)] || {})[selectedDate] || []);

    if (!daySlots.length) {
      timesEl.innerHTML = '<p class="appt__status">No available times for this day.</p>';
      timesEl.classList.remove('appt__times--hidden');
      return;
    }

    timesEl.classList.remove('appt__times--hidden');
    daySlots.forEach(function (iso) {
      var btn         = document.createElement('button');
      btn.type        = 'button';
      btn.className   = 'appt__time' + (iso === selectedSlot ? ' appt__time--selected' : '');
      btn.textContent = formatTimeRange(iso);
      btn.dataset.iso = iso;
      btn.addEventListener('click', function () { selectSlot(this.dataset.iso); });
      timesEl.appendChild(btn);
    });
  }

  function selectSlot(iso) {
    selectedSlot = iso;
    renderTimes();
    continueBtn.classList.remove('appt__continue-btn--hidden');
  }

  // ─── Continue → Confirm ───────────────────────────────────────────────────
  if (continueBtn) {
    continueBtn.addEventListener('click', function () {
      if (!selectedSlot) return;
      injectFormProperties();
      requestCycleIntent();
      selectedDtEl.textContent = formatConfirmDate();
      showPane('confirm');
      scrollFormToTop();
    });
  }

  // ─── Form ────────────────────────────────────────────────────────────────
  function injectFormProperties() {
    if (!productForm) return;
    // Derive the date label from the slot instant itself, pinned to ET — the
    // same clock the time label uses. Deriving it from the selected grid day
    // (or formatting in the visitor's timezone) can write a date that
    // contradicts _slot_iso, which is what the calendar sync actually books.
    var dateStr = new Date(selectedSlot).toLocaleDateString('en-US', {
      month: 'long', day: 'numeric', year: 'numeric', timeZone: 'America/New_York',
    });
    var timeStr = new Date(selectedSlot).toLocaleTimeString('en-US', {
      hour: 'numeric', minute: '2-digit', timeZone: 'America/New_York',
    });
    setHidden('properties[Appointment Date]',  dateStr);
    setHidden('properties[Appointment Time]',  timeStr + ' ET');
    setHidden('properties[_slot_iso]',          selectedSlot);
    setHidden('properties[_appointment_type]', appointmentType);
  }

  function setHidden(name, value) {
    var el = productForm.querySelector('[name="' + name + '"]');
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = name;
      productForm.appendChild(el);
    }
    el.value = value;
  }

  // ─── Supercycle cycle intent ─────────────────────────────────────────────
  function resaleOptionFor(variantId) {
    return resaleOptions.find(function (o) {
      if (!o || !o.global_id) return false;
      if (o.variant_application_type !== 'some') return true;
      return (o.variant_application_shopify_ids || []).indexOf(variantId) !== -1;
    });
  }

  var intentInputNames = [];
  var intentSeq = 0;

  function clearIntentInputs() {
    intentInputNames.forEach(function (name) {
      var el = productForm && productForm.querySelector('[name="' + name + '"]');
      if (el) el.parentNode.removeChild(el);
    });
    intentInputNames = [];
  }

  // Ask Supercycle for the line item attributes (properties[_cycle] and a
  // selling_plan) that turn this appointment into a resale cycle, and put them
  // on the form. The card-auth snippet copies them into its /cart/add.js call.
  // If the request fails the appointment still books, just without a cycle:
  // a lost no-show fee beats a lost booking.
  function requestCycleIntent() {
    if (!productForm) return;
    clearIntentInputs();

    var option = resaleOptionFor(selectedVariantId);
    if (!option) return;

    var seq = ++intentSeq;
    intentPending = true;
    syncAddBtn();

    fetch(INTENT_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ variant_id: selectedVariantId, option: { global_id: option.global_id } }),
    })
      .then(function (r) { return r.ok ? r.json() : r.json().then(function (d) { throw d; }); })
      .then(function (intent) {
        if (seq !== intentSeq) return; // a newer request superseded this one
        var attrs = (intent && intent.attributes) || {};
        Object.keys(attrs).forEach(function (name) {
          if (attrs[name] === null || attrs[name] === undefined) return;
          setHidden(name, attrs[name]);
          intentInputNames.push(name);
        });
      })
      .catch(function (err) {
        console.error('[IOM] Supercycle intent failed; booking without a cycle', err);
      })
      .then(function () {
        if (seq !== intentSeq) return;
        intentPending = false;
        syncAddBtn();
      });
  }

  // ─── Formatting helpers ───────────────────────────────────────────────────
  function isoDay(date) {
    var y = date.getFullYear();
    var m = String(date.getMonth() + 1).padStart(2, '0');
    var d = String(date.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + d;
  }

  // YYYY-MM-DD of an instant as seen from the showroom's timezone. Use this
  // (never isoDay) whenever the Date represents a real moment in time, so day
  // bucketing can't drift for visitors whose device clock is far from ET.
  function isoDayET(date) {
    return date.toLocaleDateString('en-CA', { timeZone: 'America/New_York' });
  }

  function formatTimeRange(isoStr) {
    var start = new Date(isoStr);
    var end   = new Date(start.getTime() + 60 * 60 * 1000);
    var opts  = { hour: 'numeric', timeZone: 'America/New_York' };
    var s     = start.toLocaleTimeString('en-US', opts).replace(' ', '');
    var e     = end.toLocaleTimeString('en-US',   opts).replace(' ', '');
    return s + '–' + e + ' ET';
  }

  function formatConfirmDate() {
    if (!selectedDate || !selectedSlot) return '';
    var dateStr = new Date(selectedSlot).toLocaleDateString('en-US', {
      month: 'long', day: 'numeric', year: 'numeric', timeZone: 'America/New_York',
    });
    var start   = new Date(selectedSlot);
    var end     = new Date(start.getTime() + 60 * 60 * 1000);
    var tOpts   = { hour: 'numeric', minute: '2-digit', timeZone: 'America/New_York' };
    var sStr    = start.toLocaleTimeString('en-US', tOpts).replace(':00', '').toLowerCase();
    var eStr    = end.toLocaleTimeString('en-US',   tOpts).replace(':00', '').toLowerCase();
    return dateStr + ' at ' + sStr + '–' + eStr + ' ET';
  }

  function setStatus(html) {
    if (statusEl) statusEl.innerHTML = html;
  }
})();
